import { Component, OnInit } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { SearchStateService } from '../../../shared/services/search-state.service';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap';
import { GwrGebaeudeSucheStandardComponent } from './gwr-gebaeude-suche-standard/gwr-gebaeude-suche-standard.component';
import { GwrGebaeudeSucheEgidComponent } from './gwr-gebaeude-suche-egid/gwr-gebaeude-suche-egid.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-gwr-gebaeude-suche',
  templateUrl: './gwr-gebaeude-suche.component.html',
  styleUrls: ['./gwr-gebaeude-suche.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    NgbNav,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLink,
    NgbNavLinkBase,
    NgbNavContent,
    GwrGebaeudeSucheStandardComponent,
    GwrGebaeudeSucheEgidComponent,
    NgbNavOutlet,
    TranslatePipe
  ]
})
export class GwrGebaeudeSucheComponent implements OnInit {
  searchMode;

  constructor(private stateService: SearchStateService) {
    keysToTranslate<string>(['gwrGebaeude.BreadcrumbSuche']);
  }

  ngOnInit() {
    this.searchMode = this.stateService.lastSearchMode || 'searchStandard';
  }
}
